export const validateEmail = (email: string): boolean => {
    return email.includes('@');
  };

export const validatePhoneNumber = (phone: string): boolean => {
    const sanitizedPhone = phone.replace(/[^\d+]/g, '');
    return sanitizedPhone.length >= 10 && sanitizedPhone.length <= 14;
  };

export const generateInstagramCode = (): string => {
  return Math.random().toString(36).substring(2, 8).toUpperCase();
};

/**
 * Normalises a handle for use as an instagramVerifications document key.
 *
 * Mirrors normalizeInstagramHandle in backend/src/utils/influencerUtils.ts. Lowercasing is not
 * cosmetic: the Instagram DM webhook keys records by the username the Graph API returns, which is
 * always lowercase, so a record written under mixed case can never be verified.
 */
export const normalizeInstagramHandle = (handle: string): string =>
  handle.trim().replace(/^@+/, '').toLowerCase();

export const validateInstagram = (handle: string): boolean => {
  // Remove @ symbol if present
  const cleanHandle = handle.replace('@', '');
  // Basic validation - ensure handle exists and follows Instagram username rules
  return /^[a-zA-Z0-9._]{1,30}$/.test(cleanHandle);
};

export const validateTikTok = (handle: string): boolean => {
  // Remove @ symbol if present
  const cleanHandle = handle.replace('@', '');
  // Basic validation - ensure handle exists and follows TikTok username rules
  // TikTok usernames can contain letters, numbers, underscores, and periods
  return /^[a-zA-Z0-9._]{1,24}$/.test(cleanHandle);
};    